var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "stack", on: { submit: _vm.onSubmit } },
    [
      _c("FileUpload", {
        key: _vm.fileUploadKey,
        attrs: {
          label: _vm.fileUploadLabel,
          "upload-percentage": 0,
          noMultiple: "",
          acceptedFileTypes: _vm.allowedExtensions.join(",")
        },
        on: { "files-changed": _vm.onChangeUploadPhotoFile }
      }),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Upload een JPG-bestand van maximum " +
            _vm._s(_vm.maximumFileSize) +
            "."
        )
      ]),
      _vm._v(" "),
      !_vm.isSubmitDisabled
        ? _c("div", [
            _c(
              "button",
              { staticClass: "btn btn-primary", attrs: { type: "submit" } },
              [_vm._v(_vm._s(_vm.submitLabel))]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }